import React, { useEffect, useState } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://admin.manomedeiros.com.br/api';

const fallbackPublications = [
  {
    title: 'Currículo Lattes',
    url: 'https://buscatextual.cnpq.br/buscatextual/visualizacv.do?id=K9187719A2&tokenCaptchar=03AFcWeA6LUzYFCefs8zQhTfgDDdC8ceVMPOyb77B9qVCyOR-EGsP-YM7K9M4Ks_aFF7aajsCFiSCsgZ7j-moMGcfvRkr3iL3HAcfv9sM1KAx5_G51K2wRarAEjVCHFqNnOBjdDYZu1cPlUWHcZz0V_WdiKHZUxDskh6qgc6LnhSSM9-qR-J8nZRMd4dnUkMTwe7TSmOHgbJ9HiEquTZYarCF3ECv7VKVXSh592LHv3o0ACn2dhEkuqFWFJUtn85ZDHoTmP3uyP_2yPPV9MMWNd7_KbwC9bhuVcXx5fsaAVZhuBfxXocNimqIJ_nDswAGAEg-wODyKKXxGQawRHy3UqKnUKu9zWpFhlYgaItNgfpy_OXxNwfXs6zuQDgeSq3bNZogO7mD8gtaRXWnHJ2oDk39nnoicRgDgICoYxYoSJ_7jAYRr2hPTrervjZTkKV3O1C0PXh9t-GCuZ4FymvM4SKxjR7udtYL91DOirNbI1trCTWArxA0TCw4g1EturHXXLu6QxzV_R_2JYop2szTtt3WdNBAUh8TyR3G4a3LMgAX5n0301MYHZEljkMq2CDbrL9rDfVMPsLwp5NGTAvhwuRWitbvRTIzFWmM1qbj67m-rxLThgjE6Ul3FSu687nnq8WmbNN1hxzPOgmEfLLw4-FTb5McNMOGGh4VWiDfj-2_rrS6C70I0ZsWIXdC24zVqMf__-By52J0eOAS85BtFdaNDaZe1GxMeaITk0bZVLeSvpO51bs_IPATEpU5mstkUBhlFldrlrfx016vorw7kY3WCHU-F4ugT2QQA1r0E8H5_VkRnJRPq4VUfwKg6DPMX-TxulCmg9IYbHtI4aGO6SPu7hs3DHuoi3n4ftqfxEpzolSkANVhUfmoBjN1dLTf5BcRY1kq0B_JS0abX0uxLY9HidAStJBJ3AkjXGjnMDxpLOO1ku_xcxLQ',
  },
  {
    title: 'Como fazer um atendimento médico inclusivo? – DrauzioCast #196',
    url: 'https://drauziovarella.uol.com.br/podcasts/drauziocast/como-fazer-um-atendimento-medico-inclusivo/amp/',
  },
  {
    title: 'Participação no Podcast Viveração - Estigmas e saúde mental',
    url: 'https://open.spotify.com/episode/1T7rMc4hv0CdCjqRyi15s5?si=7RE91Q0RSr2R4ffuhA6vKw',
  },
  {
    title: 'QUANDO O SILÊNCIO ECOA: O MANEJO TERAPÊUTICO SISTÊMICO DO SEGREDO EM INTERFACE COM O HIV/AIDS',
    url: 'https://cefi.phl.bib.br/uploads/arquivo/1718126206.pdf',
  },
  {
    title: 'COMO UMA ORGANIZAÇÃO NÃO-GOVERNAMENTAL PODE CONTRIBUIR PARA AS BOAS PRÁTICAS EM SAÚDE COM A POPULAÇÃO LGBTI+?',
    url: 'https://publicacoes.abennacional.org.br/wp-content/uploads/2023/03/C10-Manoela-Coimbra-de-Medeiros.pdf',
  },
  {
    title: 'Verbetes no livro Direitos humanos: entre A & Z',
    url: 'http://www.bibliotecadigital.ufrgs.br/da.php?nrb=001217967&loc=2025&l=173bf9e08645fd0b',
  },
];

function Publicacoes() {
  const [publications, setPublications] = useState(fallbackPublications);

  useEffect(() => {
    let isMounted = true;

    fetch(`${API_BASE_URL}/publicacoes`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro ao carregar publicações.');
        }

        return response.json();
      })
      .then((data) => {
        if (isMounted && Array.isArray(data) && data.length > 0) {
          setPublications(data);
        }
      })
      .catch(() => {
        if (isMounted) {
          setPublications(fallbackPublications);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="content-section">
      <h2 className="m-3 text-center">Publicações</h2>

      {publications.map((publication) => (
        <p className="justificar-texto" key={publication.url}>
          <a className="text-dark" target="_blank" rel="noreferrer" href={publication.url}>
            {publication.title}
          </a>
        </p>
      ))}
    </div>
  );
}

export default Publicacoes;
